import React from "react";
import { connect } from "react-redux";
import { mapScore } from "../../utils/mapScore";
import { CHAPTERS, getChapterIndex } from "../Score/storyline";

import "./Pipe.css";
const Pipe = ({ x, pipes, theme }) => {
  return (
    <div className="Pipe">
      {pipes.map(({ topHeight }, i) => (
        <div key={`pipe-${i}`} style={{ position: "relative" }}>
          <div
            className={`Pipe-top Pipe-top--${theme}`}
            style={{
              left: x + i * 200,
              height: topHeight,
              transition: "left 200ms",
            }}
          ></div>
          <div
            className={`Pipe-bottom Pipe-bottom--${theme}`}
            style={{
              left: x + i * 200,
              top: topHeight + 100,
              transition: "left 200ms",
            }}
          ></div>
        </div>
      ))}
    </div>
  );
};

const mapStateToProps = ({ Pipe }) => {
  return {
    x: Pipe.x,
    pipes: Pipe.pipes,
    theme: CHAPTERS[getChapterIndex(mapScore(Pipe))].theme,
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Pipe);
